module.exports = __webpack_public_path__ + "static/img/dkl.f20dbe8.png";